import Swiper, { Autoplay, Pagination } from 'swiper';
Swiper.use([Autoplay, Pagination]);

class Gallery {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.swiper = null;
        this.bullets = this.root.querySelector('[data-gallery-bullets]');

        return true;
    }

    init() {
        this.swiper = new Swiper(this.root, {
            loop: true,
            slidesPerView: 'auto',
            autoplay: {
                delay: 2000,
            },
            pagination: {
                el: this.bullets,
                clickable: true,
                renderBullet: function (index, className) {
                    return `<span class="${className}"></span>`;
                },
            },
        });
    }
}

export default Gallery;
